import { createActions } from 'redux-actions';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { PolicyBenefitLimit } from '@models/PolicyBenefitLimit';
import {
  GetInsurancePolicyUserParams,
  GetAllHealthPolicyBenefitLimitsWithAccumulatedPaidAmountsParams
} from '@apis/InsurancePolicyUserApi';

export type State = {
  policyUser?: InsurancePolicyUser | null;
  healthPolicyBenefitLimitsWithAccumulatedPaidAmounts?: PolicyBenefitLimit[] | null;
};

export type InsurancePolicyUserFetchPayload = GetInsurancePolicyUserParams;
export type InsurancePolicyUserHealthPolicyBenefitLimitsFetchPayload = GetAllHealthPolicyBenefitLimitsWithAccumulatedPaidAmountsParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyUserFetch,
  insurancePolicyUserHealthPolicyBenefitLimitsFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_USER_FETCH',
  'INSURANCE_POLICY_USER_HEALTH_POLICY_BENEFIT_LIMITS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_POLICY_USER_DETAILS_PAGE',
  },
);
